import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconPencil.tsx
const IconPencil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m15.728 9.577-1.414-1.414L5 17.476v1.415h1.414zm1.414-1.414 1.414-1.415-1.414-1.414-1.414 1.414zm-9.9 12.728H3v-4.243L16.435 3.213a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.414z"
	})]
});
var IconPencil_default = forwardRef(IconPencil);
//#endregion
export { IconPencil_default as default };
